var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChalk2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 23,
    viewBox: "0 0 10 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21169 0.176716C3.34473 0.0626815 3.51418 0 3.6894 0H8.75574C9.16114 0 9.48978 0.328642 9.48978 0.734043V19.7328C9.48978 19.9471 9.39614 20.1507 9.23344 20.2901L6.27808 22.8233C6.14504 22.9373 5.9756 23 5.80038 23H0.734043C0.328642 23 0 22.6714 0 22.266V3.26721C0 3.05292 0.0936364 2.84934 0.256334 2.70988L3.21169 0.176716ZM3.96094 1.46809L2.71835 2.53317H5.52884L6.77143 1.46809H3.96094ZM8.02169 2.33001L6.53442 3.60482V20.67L8.02169 19.3952V2.33001ZM5.06633 21.5319V4.00125H1.46809V21.5319H5.06633Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChalk2);
export default __webpack_public_path__ + "static/media/chalk-2.f3c53feaa5074beecd9e1fa18862cc43.svg";
export { ForwardRef as ReactComponent };